<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-loader v-if="showLoader" :text="`${loaderText}...`" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AldAutomotive',

  components: {},

  computed: {
    showLoader() {
      return this.$store.getters['ui/data']('loader');
    },

    loaderText() {
      return this.$store.getters['ui/data']('loaderText') || this.$t('message.generic.loadingData');
    }
  },

  mounted() {
    this.$cookiebot.consentBanner();
    this.setTheme(this.$store.getters['ui/data']('theme'));
    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
